import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { Bem } from '../../service/Bem/Bem';
import { formatNumber } from '../../service/FormatHelpers/FormatHelpers';
import { CurrencyCode } from '../../typings/graphql-grid';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { Shape2, Shape2Icon, Shape2Tone } from '../Shape2/Shape2';

import './WalletButton.css';
import * as keyset from './WalletButton.i18n';

const i18n = i18nFactory(keyset);

interface WalletButtonProps {
    url: string;
    sum?: number;
    currency?: CurrencyCode;
    onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

export const WalletButton = React.memo(
    ({ sum, url, currency, onClick }: WalletButtonProps) => {
        const shape = (
            <Shape2
                cls={Bem.cls('wallet-button', 'icon')}
                width={11}
                height={10}
                icon={Shape2Icon.wallet}
                tone={
                    sum !== undefined && sum <= 0
                        ? Shape2Tone.white
                        : Shape2Tone.dark
                }
            />
        );
        const cls = Bem.cls('wallet-button');

        if (sum === undefined || currency === undefined) {
            return (
                <ButtonDecorator
                    cls={cls}
                    theme={'pseudo'}
                    size={'s'}
                    view="default"
                    tone="default"
                    type="link"
                    url={url}
                    onClick={onClick}
                >
                    {shape} {i18n('wallet-button')}
                </ButtonDecorator>
            );
        }

        if (sum <= 0) {
            return (
                <ButtonDecorator
                    cls={cls}
                    theme={'raised'}
                    size={'s'}
                    view="default"
                    tone="red"
                    type="link"
                    url={url}
                    title={i18n('low-sum-hint')}
                    onClick={onClick}
                >
                    {shape} {formatNumber(sum, 2)}
                    {` ${mapStringToCurrencySymbol(currency)}`}
                </ButtonDecorator>
            );
        }

        return (
            <ButtonDecorator
                cls={cls}
                theme={'pseudo'}
                size={'s'}
                view="default"
                tone="default"
                type="link"
                url={url}
                onClick={onClick}
            >
                {shape} {formatNumber(sum, 2)}
                {` ${mapStringToCurrencySymbol(currency)}`}
            </ButtonDecorator>
        );
    }
);
